/*----------------------
    LOCATION INFO
---------------------- */

locationInfoSlider = {
    init: function () {
        new Swiper('.swiper--location-info', {
            slidesPerView: "auto",
            loop: true,
            effect: "fade",
            speed: 2000,
            allowTouchMove: false,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
        });
    }
};


$(function () {
    locationInfoSlider.init();
});